import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Cookie from "js-cookie";
import { httpPostAdditionalAccessRequestForVendor } from "../../../../../service/httpClient";
import RequestTypeSelection from "./RequestTypeSelection";
import AccessForExistingProduct from "./AccessForExistingProduct";
import AccessForNewProduct from "./AccessForNewProduct";
import FinalSubmission from "./FinalSubmission";
import {
  REQ_TYPE_ACCESS_REQUEST,
  REQ_TYPE_NEW_REQUEST,
} from "../../../../../constants/Constants";
import "./style.css";

const AddSecondUserContainer = ({
  closeHandler,
  corpName,
  dunsNo,
  canVendorInitiate,
}) => {
  const [requestType, setRequestType] = useState(null);
  const [isInformationGathered, setIsInformationGathered] = useState(false);
  const [isActionInProgress, setIsActionInProgress] = useState(false);
  const [accessRequestError, setAccessRequestError] = useState("");

  useEffect(() => {
    return () => setAccessRequestError("");
  }, []);

  useEffect(() => {
    if (canVendorInitiate) {
      setRequestType(REQ_TYPE_NEW_REQUEST);
    }
  }, [canVendorInitiate]);

  const handleClose = () => {
    closeHandler();
  };

  const setRequestTypeHandler = (type) => {
    setRequestType(type);
  };

  const getModalTitle = () => {
    if (!requestType && !isInformationGathered) return "WARNING !";
    if (requestType === REQ_TYPE_ACCESS_REQUEST && !isInformationGathered)
      return "Request Access to an Existing Vendor Record";
    if (requestType === REQ_TYPE_NEW_REQUEST && !isInformationGathered)
      return "New Product/Fulfillment Type for Existing Vendor";
    if (requestType === REQ_TYPE_ACCESS_REQUEST && isInformationGathered)
      return "Request Access to an Existing Vendor Record";
    if (requestType === REQ_TYPE_NEW_REQUEST && isInformationGathered)
      return "New Product/Fulfillment Type for Existing Vendor";

    return "";
  };

  const getFinalMessage = () => {
    if (requestType === REQ_TYPE_ACCESS_REQUEST && isInformationGathered)
      return "Thank you! Your request has been received. You will receive an email notification when this is complete.";
    if (requestType === REQ_TYPE_NEW_REQUEST && isInformationGathered)
      return "Thank you! Your submission has been received. It will be reviewed by our merchandising and operations teams. You will receive an email notification when your request has been approved and you can add all remaining details.";

    return "";
  };

  const setAccessRequestInformation = (values) => {
    setIsActionInProgress(true);

    if (requestType) {
      let dataToSubmit = {
        ...values,
        requestType,
        userEmail: Cookie.get("email"),
        vendorCorpName: corpName,
        vendorName: Cookie.get("userName") ? Cookie.get("userName") : "",
      };
      setAccessRequestError("");
      httpPostAdditionalAccessRequestForVendor(dataToSubmit)
        .then((res) => {
          if (res.data.success) {
            setIsInformationGathered(true);
          } else {
            setAccessRequestError(
              res.data.message || "There is some problem raising this request !"
            );
          }
          setIsActionInProgress(false);
        })
        .catch(({ response }) => {
          let msg = response.data
            ? response.data.message
            : "There is some problem raising this request !";
          setAccessRequestError(msg);
          setIsActionInProgress(false);
        });
    }
  };

  const submitAccessRequestInformation = () => {
    handleClose();
  };

  return (
    <Modal show={true} onHide={handleClose} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{getModalTitle()}</Modal.Title>
      </Modal.Header>
      {!requestType && !isInformationGathered && (
        <RequestTypeSelection typeChangeHandler={setRequestTypeHandler} />
      )}
      {requestType === REQ_TYPE_ACCESS_REQUEST && !isInformationGathered && (
        <AccessForExistingProduct
          submitHandler={setAccessRequestInformation}
          duns={dunsNo}
          actionInProgress={isActionInProgress}
          errMsg={accessRequestError}
        />
      )}
      {requestType === REQ_TYPE_NEW_REQUEST && !isInformationGathered && (
        <AccessForNewProduct
          submitHandler={setAccessRequestInformation}
          duns={dunsNo}
          actionInProgress={isActionInProgress}
          errMsg={accessRequestError}
        />
      )}
      {requestType && isInformationGathered && (
        <FinalSubmission submitHandler={submitAccessRequestInformation}>
          {getFinalMessage()}
        </FinalSubmission>
      )}
    </Modal>
  );
};

export default AddSecondUserContainer;
